<form *ngIf="form" [formGroup]="form" (ngSubmit)="confirm(form)">
	<div class="main">
		<div>
			<b class="required">Номер сертификата:</b>
			<app-textbox formControlName="serualNumber" maxLength="255" name="Номер сертификата"></app-textbox>
            <!-- <app-textarea formControlName="serualNumber" maxLength="255" name="Номер сертификата" [rows]="2"></app-textarea> -->
		</div>
	</div>
	<footer>
		<button class="save" appSkin="action-save bold">Привязать ЭЦП</button>
		<button type="button" class="save" appSkin="simple no-shadow bold bordered" (click)="close()">Закрыть</button>
	</footer>
</form>
